import { Button } from '@lms/ui/button';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@lms/ui/dialog';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@lms/ui/dropdown-menu';
import { EllipsisVerticalIcon, TrashIcon } from 'lucide-react';
import { useState } from 'react';
import { useSWRConfig } from 'swr';
import { useTranslations } from 'use-intl';
import { useBrand } from '@/features/branding/brand-provider';
import { removeUser, usersKey } from './users-api';

// Ports app/[brand]/admin/users/_components/overflowmenu.tsx. The Next app
// delegated to the shared `DeleteConfirmationMenu` (dropdown + confirm dialog,
// refreshing the router on success). That shared component is not yet ported,
// so its behaviour is inlined here, revalidating the user list via SWR instead
// of `router.refresh()`.
export default function OverflowMenu({ id }: { id: number }) {
  const t = useTranslations('admin');
  const { brand: site } = useBrand();
  const { mutate } = useSWRConfig();
  const [warningOpen, setWarningOpen] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  const handleDelete = async () => {
    setIsDeleting(true);
    try {
      await removeUser(id, site.id);
      setWarningOpen(false);
      await mutate(usersKey(site.id));
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <>
      <Dialog open={warningOpen} onOpenChange={setWarningOpen}>
        <DialogTrigger />
        <DialogContent>
          <DialogHeader>
            <DialogTitle>{t('are_you_sure')}</DialogTitle>
          </DialogHeader>
          <Button
            variant="destructive"
            className="w-full"
            onClick={handleDelete}
            disabled={isDeleting}
          >
            <TrashIcon className="mr-2 h-4 w-4" />
            {t('remove', { what: '' }).trim()}
          </Button>
        </DialogContent>
      </Dialog>
      <DropdownMenu modal={false}>
        <DropdownMenuTrigger>
          <EllipsisVerticalIcon />
        </DropdownMenuTrigger>
        <DropdownMenuContent>
          <DropdownMenuItem
            className="text-destructive"
            onClick={() => setWarningOpen(true)}
          >
            <TrashIcon className="mr-2 inline-block h-4 w-4" />
            {t('remove', { what: '' }).trim()}
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </>
  );
}
